import React from "react";

/**
 * Surface — the editorial card. Quiet, warm, with hairline border.
 * Replaces shadcn `Card` for all portal content.
 *
 * variants:
 *   - default: paper background, soft shadow
 *   - paper:   slightly darker paper (for nesting on default)
 *   - quiet:   borderless, transparent (used inside lists)
 *   - inset:   inset shadow + paper bg (used for AI / aside blocks)
 */
export function Surface({
  as: As = "section",
  variant = "default",
  padded = true,
  className = "",
  children,
  ...rest
}) {
  const base =
    "rounded-[var(--radius)] transition-colors duration-200";
  const variants = {
    default:
      "bg-white/70 backdrop-blur-[2px] border border-[rgba(0,0,0,0.06)] shadow-soft-lift",
    paper:
      "bg-[hsl(var(--background-paper))] border border-[rgba(0,0,0,0.05)]",
    quiet: "bg-transparent",
    inset:
      "bg-[hsl(var(--background-paper))]/70 border border-[rgba(0,0,0,0.04)] shadow-inner-depth",
  };
  return (
    <As
      className={`${base} ${variants[variant] || variants.default} ${
        padded ? "p-6 md:p-8" : ""
      } ${className}`}
      {...rest}
    >
      {children}
    </As>
  );
}
